import { render, staticRenderFns } from "./law.vue?vue&type=template&id=0a295b4a&scoped=true&lang=pug&"
var script = {}
import style0 from "./law.vue?vue&type=style&index=0&id=0a295b4a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a295b4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a295b4a')) {
      api.createRecord('0a295b4a', component.options)
    } else {
      api.reload('0a295b4a', component.options)
    }
    module.hot.accept("./law.vue?vue&type=template&id=0a295b4a&scoped=true&lang=pug&", function () {
      api.rerender('0a295b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/law.vue"
export default component.exports